module.exports = __webpack_public_path__ + "static/media/check_white.71ea5b24.svg";